import { Component, AfterViewInit, ViewChild, Inject } from '@angular/core';
import { AllergyService } from "../service/allergy.service";
import { AllergyDataModel } from "../../model/index"
import { Title } from '@angular/platform-browser';
import { ModalComponent } from "../../shared/modeldialog/index";
import { SecurityService } from '../../Security/security.service';
import { Router } from "@angular/router";
declare var allerfygridself: any;
declare var require: any;
declare var allergyGrid: any;
@Component({
    selector: 'MentisSoft-Allergy',
    template: require('../Template/Allergy.template.html'),
   // styles: [require('../Template/Allergy.css')]
})

export class AllergyComponent implements AfterViewInit {
    @ViewChild("viewModelPopup") viewModelPopup: ModalComponent;
    loading = false;
    constructor( @Inject(SecurityService) private _SecurityService: SecurityService, private _allergyService: AllergyService, private _titleService: Title,
        private router: Router) {
        allergyGrid = this;
    }
    
    dataSource: AllergyDataModel[] = [];
    columns: any[] = [];
	IsAllergyDataAvailable : boolean = false;

    ngAfterViewInit(): void {  
        $('#overlay').hide();     
        this._titleService.setTitle("Allergy Reports");
        this.LoadAlergyReports();
    }

    showBookingSlots() {
        this.viewModelPopup.open();
    }

    LoadAlergyReports() {       
        this.loading = true;
        this._allergyService.getAllergyReports(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser)
            .subscribe(
            p => {
                if (p.sessionExpiry && p != null && p.SessionTimeout != "Session Expired") {
                    this.loading = false;
                    this.dataSource = p.AllergyReports;
                    this.buildGrid();
                    this._SecurityService.errorMessage = "";
					if(p.AllergyReports.length == 0) {
						this.IsAllergyDataAvailable = true;
					}
                }
                else if(!p.sessionExpiry ||  p.SessionTimeout == "Session Expired") {
                    this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                    this.router.navigate(["/Login"]);    
                }
            },
            err => {
                this.loading = false;
                console.log("Error while validating...");
            });
    }

    public buildGrid() {
        try {
            this.buildColumn();

            var dgrid = jQuery("#grdAllergyResults").data("kendoGrid");
            if (dgrid) {
                $('#grdAllergyResults').data().kendoGrid.destroy();
                $('#grdAllergyResults').empty();
            }
            jQuery('#grdAllergyResults').kendoGrid({
                editable: false,
                filterable: true,
                pageable: {
                    pageSizes: [10, 25, 50, 100]
                },
                scrollable: false,
                sortable: true,
                columns: this.columns,
                dataBinding: this.databinding,               
                dataSource: {
                    data: this.dataSource,
                    pageSize: this.dataSource != null ? 10 : 0,
                },
            });
            jQuery("#grdAllergyResults").data("kendoGrid").wrapper.children(".k-grid-pager").find("span.k-input").html('All');
            var gridPage = jQuery("#grdAllergyResults").data("kendoGrid");
            gridPage.wrapper.children(".k-grid-pager").find("span.k-input").html('10');
            var pageSizeDropDownList = gridPage.wrapper.children(".k-grid-pager").find("select").data("kendoDropDownList");
            pageSizeDropDownList.bind("change", function (e: any) {
                gridPage.wrapper.children(".k-grid-pager").find("span.k-input").html(gridPage.wrapper.children(".k-grid-pager").find("select").find('option:selected').text());
            });
        }
        catch (ex) {
            this.handleError(ex);
        }
    }

    buildColumn(): void {
        this.columns = [
            {                
                field: "AlertName",
                title: "Name",
            },
            {               
                field: "Severity",
                title: "Severity",
            },
            {              
                field: "Reaction",
                title: "Reaction",
            },
            {              
                field: "Remarks",
                title: "Remarks",
            },
            {                
                field: "Active",
                title: "Active",
            }
        ];
    }  

    databinding(e: any) {
        try {
            var grid = jQuery("#grdAllergyResults").data("kendoGrid");
            var totalCount = grid.dataSource.total();
            var pageSizes = [{ text: "10", value: 10 }, { text: "25", value: 25 }, { text: "50", value: 50 }, { text: "100", value: 100 }, { text: "All", value: totalCount }];
            var pagerdropdownBox = jQuery('.k-pager-sizes select[data-role="dropdownlist"]').data('kendoDropDownList');
            var pagerds = new kendo.data.DataSource({
                data: pageSizes
            });
            pagerdropdownBox.setDataSource(pagerds);
        }
        catch (e) {
        }
    }

    private handleError(error: any) {
        console.log("error : " + error);
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/allergy/component/allergy.component.ts